import React, {Component} from 'react';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import {Parser} from 'html-to-react';

import ArtifactDialog from './ArtifactDialog';


class TextEntryRender extends Component {
    htmlToReactParser = new Parser();
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    renderTextEntry() {
        console.log(this.props.submission);
        var htmlParser = new Parser();
        if(this.props.submission.body) {
            var reactElement = htmlParser.parse(this.props.submission.body);
            return reactElement;
        } else {
            return(<div></div>)
        }

    }

    renderDescription() {
        return (
            <div>
                <h1>{this.props.submission.canvas_assignment_name}</h1>
                <hr/>
                <h2>Assignment Description</h2>
                <h3>
                    {this.htmlToReactParser.parse(this.props.submission.canvas_assignment_description.replace(/(\\r\\n|\\n|\\r)/gm," "))}
                </h3>
                <hr/>
            </div>
        );
    }

    render() {
        return (
            <ArtifactDialog title="Text Entry Artifact" isReviewed={this.props.isReviewed} submission={this.props.submission}>
                {this.renderDescription()}
                {this.renderTextEntry()}
            </ArtifactDialog>
        )
    }
}

export default withMobileDialog()(TextEntryRender);


